/**
 * PublicBodyRegisterCatalogService - Helper for active (non-invalidated) public-body registers.
 *
 * Centralizes the "fetch + filter invalidated" logic so pages stay thin and consistent.
 */
import CSORegisterService from '@/shared/services/cso/CSORegisterService';

class PublicBodyRegisterCatalogService {
  /**
   * @returns {Promise<Array>} Active registers (invalidated=false)
   */
  async getActive() {
    const registers = await CSORegisterService.getAllPublicBodyRegisters();
    return (registers || []).filter((reg) => !reg?.invalidated);
  }
}

const instance = new PublicBodyRegisterCatalogService();
export default instance;

